import { useContext } from 'react';
import { useEffect, useState } from 'react';
import { Container, Typography, Switch, Box, Tooltip } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useSelector } from 'src/reducers';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { MoreMenu, DataGridRender } from 'src/components/table';
import MessageContext from 'src/context/MessageContext';
import ReactCountryFlag from "react-country-flag"
import { ClientAllRequest, ClientDeleteRequest, ClientStatusUpdateRequest } from 'src/actions/clientActions';
import TopBar from 'src/components/shared/TopBar';

export default function ClientList() {

  const { setMessageHandler } = useContext<any>(MessageContext);
  const [pageNo, setPageNo] = useState(1);
  const [limit, setLimit] = useState(10);
  const [status] = useState(false);
  const [filters, setFilters] = useState<any>({});
  const [search, setSearch] = useState<string>('');

  const dispatch = useDispatch();
  const { loading, metadata, data } = useSelector(state => state.client);

  const navigate = useNavigate();

  useEffect(() => {
    dispatch(ClientAllRequest(filters, search, pageNo, limit, status));
  }, [pageNo, search, limit, status, filters]);


  const deleteAction = (id: string) => {
    dispatch(ClientDeleteRequest(id, { isDeleted: true }, setMessageHandler));
  }
  const editAction = (id: string) => {
    navigate(`/admin/client/${id}/edit`);
  }

  const columns = [
    {
      field: 'clientName', type: "string", headerName: 'Client Name', filterable: false, headerAlign: "left", align: 'left', width: 200, renderCell: ({ id, value }: any) => {
        return <Tooltip title={value}>
          <RouterLink to={`/admin/client/${id}/edit`}> <Typography onClick={() => editAction(id)} color="primary" >{value}</Typography></RouterLink>
        </Tooltip>
      }
    },
    {
      field: 'countryName', type: "string", headerName: 'Region', filterable: false, flex: 1, headerAlign: "left", align: 'left',
      renderCell: (params: any) => {
        return <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <ReactCountryFlag className="emojiFlag" countryCode={`${params.row.countryCode}`} /><Tooltip title={params.row.countryName}>
            <Typography sx={{ ml: 1 }} variant="subtitle2">{params.row.countryName}</Typography>
          </Tooltip>
        </Box>
      },
    },
    { field: 'totalProjects', type: "string", headerName: 'Total Projects', filterable: false, flex: 1, headerAlign: "center", align: 'center' },
    { field: 'activeProjects', type: "string", headerName: 'Active Projects', filterable: false, flex: 1, headerAlign: "center", align: 'center' },
    { field: 'responded', type: "string", headerName: 'Traffic', filterable: false, flex: 1, headerAlign: "center", align: 'center' },
    { field: 'completed', type: "string", headerName: 'Complete', filterable: false, flex: 1, headerAlign: "center", align: 'center' },
  //  { field: 'approved', type: "string", headerName: 'Approved', filterable: false, flex: 1, headerAlign: "center", align: 'center' },
    // {
    //   field: 'actualRevenue', type: "string", headerName: 'A.Revenue', filterable: false, flex: 1, headerAlign: "center", align: 'center',
    //   renderCell: (params: any) => {
    //     return "$ " + params.row.actualRevenue
    //   },
    // },
    {
      field: 'expectedRevenue', type: "string", headerName: 'Expected Revenue', filterable: false, flex: 1, headerAlign: "center", align: 'center',
      renderCell: (params: any) => {
        return "$ " + params.row.expectedRevenue
      },
    },
  //  { field: 'arRate', type: "string", headerName: 'A.Rate', filterable: false, flex: 1, headerAlign: "center", align: 'center' },
    {
      field: 'isActive', headerName: 'Status', type: "number", width: 80, valueFormatter: ({ value }: any) => value ? "Active" : "InActive",
      renderCell: (params: any) => {
        return <Switch checked={params.value} onChange={() => dispatch(ClientStatusUpdateRequest(params.id, { isActive: !params.value }, setMessageHandler))} />
      }
    },
    { field: 'actions', headerName: '', width: 40, type: 'actions', getActions: ({ id, row }: any) => [<MoreMenu id={id} name={row['clientCode'] + row['clientName']} cloneAction="" addAction='' editAction={editAction} deleteAction={deleteAction} exportAction="" />] },
  ];


  return (
    <Container maxWidth={false}>
      <TopBar title="Clients" link="/admin/client/add" buttonText="New Client" />
      <DataGridRender
        width={1}
        loading={loading}
        height={620}
        filterTypes={['countries', 'status', 'export', 'search']}
        exportFileName={"Clients"}
        filters={filters}
        data={data}
        metadata={metadata}
        limit={limit}
        search={search}
        pageNo={pageNo}
        columns={columns}
        setPageNo={setPageNo}
        setSearch={setSearch}
        setLimit={setLimit}
        setFilters={setFilters}
      />
    </Container>
  );
}
